var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreativeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbd4ce",
    fillRule: "evenodd",
    d: "M12 3.75a6.25 6.25 0 0 0-2.678 11.899l.428.203v2.398h1.5v-3.94l-2.78-2.78 1.06-1.06L12 12.94l2.47-2.47 1.06 1.06-2.78 2.78v3.94h1.5v-2.398l.428-.203A6.25 6.25 0 0 0 12 3.75zM4.25 10a7.75 7.75 0 1 1 11.5 6.784v2.966h-7.5v-2.966a7.748 7.748 0 0 1-4-6.784zM14 20.75v1.5h-4v-1.5z",
    clipRule: "evenodd",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeIcon);
export default __webpack_public_path__ + "static/media/creative-icon.81d7c4aaa5a663a967070e698c79776d.svg";
export { ForwardRef as ReactComponent };